import { createStyles } from '@material-ui/core/styles';

const TransferStyle = createStyles({
  elementContainer: {
    display: 'grid',
  },
});

export default TransferStyle;
